export default "__VITE_ASSET__fe1eda56__"